// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

const EllipsisText = styled.div`
    display: inline-block;

    width: ${props => props.boxWidth || '100%'};
    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;

    vertical-align: bottom;
`;

export default EllipsisText;
